import type { GlobalDataFileCounts } from "../api/hooks/useGlobalData";

export function describeFileCounts(counts: GlobalDataFileCounts): string {
  const parts = [`${counts.ready} ready`];
  if (counts.extracting > 0) parts.push(`${counts.extracting} extracting`);
  if (counts.failed > 0) parts.push(`${counts.failed} failed`);
  if (counts.removed > 0) parts.push(`${counts.removed} removed`);
  return parts.join(" · ");
}
